import React, {
  forwardRef,
  memo,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { Tooltip } from "antd";
import { MdOutlineFormatListNumbered } from "react-icons/md";

import HistoryBlockModal from "../../../../components/creditCard/modals/HistoryBlockModal/HistoryBlockModal";
import { HistoryBlockModalHandle } from "../../../../components/creditCard/modals/HistoryBlockModal/types";
import { usePermissions } from "../../../../Context/permissionContext";
import * as Style from "../CardMenu/style";

type HistoryCard = {
  id?: number | string;
  status?: string;
};

type HistoryBlockActionProps = {
  card: HistoryCard;
  isBandeirado?: boolean;
  standalone?: boolean;
};

export type HistoryBlockActionHandle = {
  getData: () => void | Promise<void>;
};

const HistoryBlockAction = forwardRef<
  HistoryBlockActionHandle,
  HistoryBlockActionProps
>(function HistoryBlockAction(
  { card, isBandeirado, standalone = false },
  ref
) {
  const { permissions } = usePermissions();
  const modalRef = useRef<HistoryBlockModalHandle>(null);
  const [isHistoryBlockModalVisible, setHistoryBlockModalVisible] =
    useState(false);
  const hasPermissionToViewHistory = permissions?.includes("view_history");

  useImperativeHandle(ref, () => ({
    getData: () => modalRef.current?.getData(),
  }));

  const toggleHistoryBlockModal = useCallback(() => {
    if (!hasPermissionToViewHistory) return;
    setHistoryBlockModalVisible((prevState) => !prevState);
  }, [hasPermissionToViewHistory]);

  const button = (
    <Tooltip title="Histórico (bloqueios)">
      <Style.MenuItem
        type="button"
        className="border-left"
        onClick={toggleHistoryBlockModal}
        disabled={!hasPermissionToViewHistory}
        data-testid={`botao_historico_bloqueio_${card?.id}`}
      >
        <MdOutlineFormatListNumbered className="icon" />
        Histórico
      </Style.MenuItem>
    </Tooltip>
  );

  return (
    <>
      <HistoryBlockModal
        ref={modalRef}
        isModalVisible={isHistoryBlockModalVisible}
        closeModal={toggleHistoryBlockModal}
        card={card}
        isBandeirado={!!isBandeirado}
      />
      {standalone ? (
        <Style.Wrapper>
          <Style.WrapperCardMenu>{button}</Style.WrapperCardMenu>
        </Style.Wrapper>
      ) : (
        button
      )}
    </>
  );
});

export default memo(HistoryBlockAction);
